import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { c1, offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { Media, MenuButton } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { listChatTags } from "src/app/core/services/outbound";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-button-option-component",
  templateUrl: "./button-option-component.component.html",
  styleUrls: ["./button-option-component.component.scss"],
})
export class ButtonOptionComponentComponent implements OnInit, OnDestroy {
  startColor: any;
  startDarkColor: any;
  endColor: any;
  endDarkColor: any;
  labelColor: any;
  labelDarkColor: any;
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private modalService: BsModalService,
    private builderService: BuilderService,
    private formBuilder: UntypedFormBuilder,
  ) {}

  @Input() button_id: string;
  button: MenuButton;
  mode: string;
  @Input() data: any;
  @Input() config: any;
  @ViewChild("largeDataModal") myModal;

  verifySubscription: any;
  selectedImages: any[] = [];
  swaperForm: UntypedFormGroup;
  submitted = false;
  collapseMedia = true;
  modalRef?: BsModalRef;
  file: any;
  aspectRatio;
  resizeToWidth = 0;
  resizeToHeight = 0;
  orgFile: any;
  uploading = false;
  isCollapsed = true;

  component_id: string;

  selectedSettings: any;
  // default values
  offCanvasSubscription: any;

  offcanvasColors = offcanvasColors;
  newTab = false;
  button_bgcolor: string;
  row_id: string;
  button_option_color = "#ffffff";
  button_option = [];
  button_value = [];
  currentMenuSubscription: any;
  listChatTagsSubscription: any;

  sortedButtonList: any[];
  buttonList: any;
  off_canvas_key: string = "button";
  selectedIcon = {};
  selected_button_value = {};
  isAndroid: boolean;
  field_id: string;
  iconType: number;

  icon: any;
  trailing_icon: any;

  text_id: any;

  imageUploaderConfig: any = {
    id: "swaper",
    title: "Image",
    max: 1,
    selectedImages: [],
    cropperView: false,
    resizeToWidth: 370,
    resizeToHeight: 370,
    removeButton: true,
    removePadding: true,
    aspectRatio: "1x1",
    fullImage: true,
    mode: ["upload", "gallery"],
  };

  optionform: UntypedFormGroup;

  sync = true;
  component_ref: any;
  chatID: string;
  pageSize = 1000;
  currentPage = 0;
  userList = {};
  tag_values: any;
  page: Array<any> = [];
  labelKey: string;
  subLabelKey: string;

  colors: any;

  colorObject: any;
  selectedColor;
  headlineColor: any;
  headlineColorDark: any;

  ngOnInit() {
    this.chatID = localStorage.getItem("chat_id");
    this.component_ref = this.mdw.makeRef(16);
    if (this.config && this.config.resizeToWidth) {
      this.imageUploaderConfig.resizeToWidth = this.config.resizeToWidth;
    }

    if (this.config && this.config.resizeToHeight) {
      this.imageUploaderConfig.resizeToHeight = this.config.resizeToHeight;
    }
    this.field_id = "label";
    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.button &&
          data.button.button_id == this.button_id
        ) {
          this.buttonIntialize(data);
          this.buttonFunction();
        }
      },
    );
    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.currentButton &&
          this.button_id &&
          data.currentButton.button_id == this.button_id &&
          data["component_id"] != this.component_id
        ) {
          this.data = data;
          this.sortedButtonList = this.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];
          this.button = data["buttonList"][this.button_id];
          this.icon;
          this.buttonFunction();
        }
      },
    );

    this.listChatTagsSubscription = this.ws.listChatTagsContainer$.subscribe(
      (listTagsData) => {
        if (listTagsData.ref === this.component_ref) {
          if (listTagsData) {
            this.currentPage = listTagsData.page_number;

            listTagsData.tags.forEach((tag: any) => {
              this.userList[String(tag.id)] = tag;
            });
            this.page = [];
            for (let i = 0; i < this.pageSize; i++) {
              if (
                Object.keys(this.userList)[
                  i + (this.currentPage - 1) * this.pageSize
                ]
              ) {
                this.page.push(
                  this.userList[
                    Object.keys(this.userList)[
                      i + (this.currentPage - 1) * this.pageSize
                    ]
                  ],
                );
              }
            }

            // this.buttonFunction();
          }
        }
      },
    );

    this.verifySubscription = this.ws.verifyContainer$.subscribe(
      (verifyData) => {
        // console.log("verifyData"+ verifyData);
        if (verifyData) {
          this.ws.processMethod(
            new listChatTags(0, this.chatID, this.component_ref),
          );
        }
      },
    );
  }

  get f() {
    return this.optionform.controls;
  }

  buttonIntialize(data) {
    this.data = data.data;

    if (data.button.button_id == this.button_id) {
      this.button = { ...data.button };
      this.component_id = this.button.button_id + this.field_id;
    }
    this.sortedButtonList = data.data["sortedButtonList"];
    this.buttonList = this.data["buttonList"];
    this.mode = localStorage.getItem("mode");
  }

  buttonFunction() {
    if (this.button) {
      this.text_id = this.config.id.split(/_(.*)/s)[1];
      this.isAndroid =
        localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      if (this.config.scheme_color) {
        this.colors = this.isAndroid
          ? this.config.scheme_color.color_schema
          : this.config.scheme_color.color_schema_ios;
      }

      if (this.config) {
        this.imageUploaderConfig.cropperView = this.config.cropperView || false;
        this.imageUploaderConfig.aspectRatio = this.config.aspectRatio || "1x1";
        this.labelKey = this.config.labelKey ? this.config.labelKey : "label";
        this.subLabelKey = this.config.sublabelKey
          ? this.config.sublabelKey
          : "sublabel";
      }

      if (this.button.button_option) {
        this.button_option = structuredClone(this.button.button_option);
        // this.selectedImages = this.button_option;
      }

      if (this.config) {
        this.imageUploaderConfig.cropperView = this.config.cropperView || false;
        this.imageUploaderConfig.aspectRatio = this.config.aspectRatio || "1x1";
      }

      if (this.button.button_value) {
        this.button_value = this.button.button_value;
        for (let i = 0; i < this.button.button_value.length; i++) {
          this.selected_button_value[this.button.button_value[i].id] =
            this.button.button_value[i];
        }
      }
    }
  }

  updateButtonData() {
    //*must be there in all buttons
    this.buttonList[this.button_id] = this.button;
    let index = this.sortedButtonList[this.button.row_id].findIndex(
      (e) => e.button_id == this.button_id,
    );
    this.sortedButtonList[this.button.row_id][index] = { ...this.button };
    this.data["sortedButtonList"] = this.sortedButtonList;
    this.data["buttonList"] = this.buttonList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["currentButton"] = this.button;

    this.mdw._currentMenuContainer.next(this.data);

    this.mdw.changeTab(
      { button: this.button, tab: { module: "menu" } },
      this.mode,
      true,
    );
  }

  addNewSwaper() {
    const swaper: any = {
      id: "o_" + this.mdw.makeRef(16),
      [this.labelKey]: "",
      [this.subLabelKey]: "",
      value: "Option-" + (this.button_option.length + 1),
      order: this.button_option.length,
    };
    if (this.config.icon) {
      swaper.icon = "";
    }
    if (this.config.image) {
      swaper.image = "";
    }
    this.button_option.push(swaper);
    this.openSettings(swaper);
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(
      this.button_option,
      event.previousIndex,
      event.currentIndex,
    );
    this.button_option = this.button_option.map((image, index) => {
      image.order = index;
      return image;
    });
    this.button.button_option = this.button_option;
    this.updateButtonData();
  }

  deleteImage(id: string) {
    this.button_option = this.button_option.filter((image) => image.id !== id);
    this.button.button_option = this.button_option;
    this.updateButtonData();
  }

  openSettings(option) {
    this.icon = null;
    this.trailing_icon = null;

    this.headlineColor =
      option &&
      option.color_schema &&
      option.color_schema.schemes &&
      option.color_schema.schemes.light &&
      option.color_schema.schemes.light.headline
        ? option.color_schema.schemes.light.headline
        : this.colors ? this.colors.schemes.light[this.config.init_color] : null;
    this.headlineColorDark =
      option &&
      option.color_schema &&
      option.color_schema.schemes &&
      option.color_schema.schemes.dark &&
      option.color_schema.schemes.dark.headline
        ? option.color_schema.schemes.dark.headline
        : this.colors ? this.colors.schemes.light[this.config.init_color_ios] : null;
    this.startColor =
      option &&
      option.color_schema &&
      option.color_schema.schemes &&
      option.color_schema.schemes.light &&
      option.color_schema.schemes.light.bgstart
        ? option.color_schema.schemes.light.bgstart
        : this.colors ? this.colors.schemes.light[this.config.init_start] : null;
    this.startDarkColor =
      option &&
      option.color_schema &&
      option.color_schema.schemes &&
      option.color_schema.schemes.dark &&
      option.color_schema.schemes.dark.bgstart
        ? option.color_schema.schemes.dark.bgstart
        : this.colors ? this.colors.schemes.light[this.config.init_start] : null;
    this.endColor =
      option &&
      option.color_schema &&
      option.color_schema.schemes &&
      option.color_schema.schemes.light &&
      option.color_schema.schemes.light.bgend
        ? option.color_schema.schemes.light.bgend
        : this.colors ? this.colors.schemes.light[this.config.init_start] : null;
    this.endDarkColor =
      option &&
      option.color_schema &&
      option.color_schema.schemes &&
      option.color_schema.schemes.dark &&
      option.color_schema.schemes.dark.bgend
        ? option.color_schema.schemes.dark.bgend
        : this.colors ? this.colors.schemes.light[this.config.init_start] : null;

    this.optionform = this.formBuilder.group({
      id: new UntypedFormControl(
        (option && option.id) || "",
        this.getValidators("id"),
      ),
      label: new UntypedFormControl(
        (option && option[this.labelKey]) || "",
        this.getValidators("label"),
      ),
      sublabel: new UntypedFormControl(
        (option && option[this.subLabelKey]) || "",
        this.getValidators("sublabel"),
      ),
      body: new UntypedFormControl(
        (option && option.body) || "",
        this.getValidators("body"),
      ),
      value: new UntypedFormControl(
        (option && option.value) || "",
        this.getValidators("value"),
      ),
      icon: new UntypedFormControl(
        (option && option.icon) || "",
        this.getValidators("icon"),
      ),
      icon_ios: new UntypedFormControl(
        (option && option.icon_ios) || "",
        this.getValidators("icon_ios"),
      ),

      trailing_icon: new UntypedFormControl(
        (option && option.trailing_icon) || "",
        this.getValidators("trailing_icon"),
      ),
      trailing_icon_ios: new UntypedFormControl(
        (option && option.trailing_icon_ios) || "",
        this.getValidators("trailing_icon"),
      ),
      image: new UntypedFormControl(
        (option && option.image) || "",
        this.getValidators("image"),
      ),
      image_ios: new UntypedFormControl(
        (option && option.image_ios) || "",
        this.getValidators("image"),
      ),
      divider: new UntypedFormControl(
        (option && option.divider) || false,
        this.getValidators("divider"),
      ),
      divider_ios: new UntypedFormControl(
        (option && option.divider_ios) || false,
        this.getValidators("divider_ios"),
      ),
      enable_tag: new UntypedFormControl(
        false,
        this.getValidators("enable_tag"),
      ),
      tag: new UntypedFormControl(
        option && option.tag
          ? this.mdw.getTagsFromBitwise(option.tag, this.page)
          : [],
        this.getValidators("tag"),
      ),
      headlineColor: new UntypedFormControl(
        this.headlineColor,
        this.getValidators("headlineColor"),
      ),
      headlineColorDark: new UntypedFormControl(
        this.headlineColorDark,
        this.getValidators("headlineColorDark"),
      ),
      bgstart: new UntypedFormControl(
        this.startColor,
        this.getValidators("bgstart"),
      ),
      bgend: new UntypedFormControl(this.endColor, this.getValidators("bgend")),
      bgstartDark: new UntypedFormControl(
        this.startDarkColor,
        this.getValidators("bgstartDark"),
      ),
      bgendDark: new UntypedFormControl(
        this.endDarkColor,
        this.getValidators("bgendDark"),
      ),
    });

    this.selectedSettings = structuredClone(option);

    if (!this.config.sublabel) {
      this.optionform.get("sublabel").disable();
    }
    if (!this.config.body) {
      this.optionform.get("body").disable();
    }
    if (!this.config.divider) {
      this.optionform.get("divider").disable();
      this.optionform.get("divider_ios").disable();
    }

    if (!this.config.icon) {
      this.optionform.get("icon").disable();
      this.optionform.get("icon_ios").disable();
    }

    if (!this.config.trailing_icon) {
      this.optionform.get("trailing_icon").disable();
      this.optionform.get("trailing_icon_ios").disable();
    }

    if (!this.config.image) {
      this.optionform.get("image").disable();
      this.optionform.get("image_ios").disable();
    }

    if (
      (this.isAndroid || this.sync) &&
      this.config.icon &&
      this.optionform.get("icon").value
    ) {
      this.icon = this.builderService.getIcon(
        this.optionform.get("icon").value,
      );
    }

    if (
      (this.isAndroid || this.sync) &&
      this.config.trailing_icon &&
      this.optionform.get("trailing_icon").value
    ) {
      this.trailing_icon = this.builderService.getIcon(
        this.optionform.get("trailing_icon").value,
      );
    }

    if (
      (!this.isAndroid || this.sync) &&
      this.config.icon &&
      this.optionform.get("icon_ios").value
    ) {
      this.icon = this.builderService.getIcon(
        this.optionform.get("icon_ios").value,
      );
    }

    if (
      (!this.isAndroid || this.sync) &&
      this.config.trailing_icon &&
      this.optionform.get("trailing_icon_ios").value
    ) {
      this.trailing_icon = this.builderService.getIcon(
        this.optionform.get("trailing_icon_ios").value,
      );
    }

    if (this.selectedSettings && this.config.image) {
      const media = {
        id: this.selectedSettings.id,
        media: {
          permanentUrl: this.isAndroid
            ? this.selectedSettings.image
            : this.selectedSettings.image_ios,
        },
      };
      this.imageUploaderConfig = {
        ...this.imageUploaderConfig,
        selectedImages: media.media.permanentUrl ? [media] : [],
      };
    }
  }

  getValidators(fieldName: string): ValidatorFn[] {
    const validators: ValidatorFn[] = [];
    const fieldConfig =
      this.config &&
      this.config["validators"] &&
      this.config["validators"][fieldName];

    if (fieldConfig) {
      if (fieldConfig.required) {
        validators.push(Validators.required);
      }
      if (fieldConfig.minLength) {
        validators.push(Validators.minLength(fieldConfig.minLength));
      }
      if (fieldConfig.maxLength) {
        validators.push(Validators.maxLength(fieldConfig.maxLength));
      }
      if (fieldConfig.email) {
        validators.push(Validators.email);
      }
      // Add more validators as needed, e.g., pattern, etc.
    }
    return validators;
  }

  saveChanges() {
    this.submitted = true;
    if (this.optionform.valid) {
      this.selectedSettings = {
        ...this.optionform.value,
        [this.subLabelKey]: this.optionform.value.sublabel,
        [this.labelKey]: this.optionform.value.label,
      };

      if(this.config.setGradient){
        this.selectedSettings["color_schema"] = {
          schemes: {
            light: {
              bgstart: this.optionform.value.bgstart,
              bgend: this.optionform.value.bgend,
            },
            dark: {
              bgstart: this.optionform.value.bgstartDark,
              bgend: this.optionform.value.bgendDark,
            },
          },
        };
        this.selectedSettings["color_schema_ios"] = {
          schemes: {
            light: {
              bgstart: this.optionform.value.bgstart,
              bgend: this.optionform.value.bgend,
            },
            dark: {
              bgstart: this.optionform.value.bgstartDark,
              bgend: this.optionform.value.bgendDark,
            },
          },
        };
      }

      if(this.config.setcolor){
        this.selectedSettings["color_schema"] = {
          schemes: {
            light: {
              ...this.selectedSettings['color_schema']['schemes']['light'],
              headline: this.optionform.value.headlineColor,
            },
            dark: {
              ...this.selectedSettings['color_schema']['schemes']['dark'],
              headline: this.optionform.value.headlineColorDark,
            },
          },
        };
        this.selectedSettings["color_schema_ios"] = {
          schemes: {
            light: {
              ...this.selectedSettings['color_schema_ios']['schemes']['light'],
              headline: this.optionform.value.headlineColor,
            },
            dark: {
               ...this.selectedSettings['color_schema_ios']['schemes']['dark'],
              headline: this.optionform.value.headlineColorDark,
            },
          },
        };
      }


      delete this.selectedSettings['bgstart'];
      delete this.selectedSettings['bgend'];
      delete this.selectedSettings['bgstartDark'];
      delete this.selectedSettings['bgendDark'];
      delete this.selectedSettings['headlineColor'];
      delete this.selectedSettings['headlineColorDark'];

      if (this.optionform.value.tag && this.optionform.value.tag.length > 0) {
        this.selectedSettings.tag = this.mdw.getBitwiseValueById(
          this.optionform.value.tag,
        );
      } else {
        delete this.selectedSettings.tag;
      }
      this.button_option = this.button_option.map((image) =>
        image.id === this.selectedSettings.id ? this.selectedSettings : image,
      );
      this.button.button_option = this.button_option;
      // update default value if original object has been changed.
      if (!this.config.hideValue) {
        this.button.button_value = this.button.button_value.map((items) =>
          items.id === this.selectedSettings.id ? this.selectedSettings : items,
        );
      }

      this.updateButtonData();
      this.openSettings(null);
    }
  }

  selectColor(mode){
    this.selectedColor = mode;
    this.labelColor = this.colorObject.light[this.selectedColor];
    this.labelDarkColor = this.colorObject.dark[this.selectedColor];
    this.optionform.patchValue({headlineColor: this.labelColor, headlineColorDark: this.labelDarkColor});
  }

  openSelector(exlargeModal: any, type) {
    this.iconType = type;
    this.modalRef = this.modalService.show(exlargeModal, { class: "modal-xl" });
  }

  changeIcon(event) {
    if (this.iconType) {
      this.trailing_icon = this.builderService.getIcon(event);
      if (this.isAndroid || this.sync) {
        this.optionform.patchValue({ trailing_icon: event });
      }
      if (!this.isAndroid || this.sync) {
        this.optionform.patchValue({ trailing_icon_ios: event });
      }
    } else {
      this.icon = this.builderService.getIcon(event);
      if (this.isAndroid || this.sync) {
        this.optionform.patchValue({ icon: event });
      }
      if (!this.isAndroid || this.sync) {
        this.optionform.patchValue({ icon_ios: event });
      }
    }
    this.modalRef.hide();
  }

  addButtonToValue(opt) {
    const valuesLength = Object.keys(this.selected_button_value).length;
    if (this.selected_button_value[opt.id]) {
      delete this.selected_button_value[opt.id];
    } else {
      if (
        this.config.maxSelected &&
        (this.config.maxSelected == -1 ||
          this.config.maxSelected > valuesLength)
      ) {
        this.selected_button_value[opt.id] = opt;
      } else {
        this.selected_button_value = {};
        this.selected_button_value[opt.id] = opt;
      }
    }

    this.button.button_value = Object.values(this.selected_button_value);
    this.updateButtonData();
  }

  getSelectedButtonValue(opt) {
    return this.selected_button_value[opt.id] ? true : false;
  }

  colorChange(value, manual) {
    let color = null;
    color =
      manual == true
        ? this.mdw.isValidHexaCode(value.target.value)
          ? value.target.value
          : null
        : value;
    if (color) {
      this.isAndroid = localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      this.colors = this.isAndroid ? this.config.scheme_color.color_schema : this.config.scheme_color.color_schema_ios;
      let customColor = this.mdw.customColor(color, this.colors.source, 'color', true);
      this.colorObject = customColor;
      this.labelColor = customColor.light[this.selectedColor ? this.selectedColor : 'color'];
      this.labelDarkColor = customColor.dark[this.selectedColor ? this.selectedColor : 'color'];
      this.optionform.patchValue({headlineColor: this.labelColor, headlineColorDark: this.labelDarkColor});
    }
  }

  startColorChange(value, manual, mode = "color") {
    let color = null;
    let onMode: string;
    if (mode == "color") {
      onMode = "colorContainer";
    } else {
      onMode = "color";
    }
    color =
      manual == true
        ? this.mdw.isValidHexaCode(value.target.value)
          ? value.target.value
          : null
        : value;
    if (color) {
      this.isAndroid =
        localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      this.colors = this.isAndroid
        ? this.config.scheme_color.color_schema
        : this.config.scheme_color.color_schema_ios;
      let customColor = this.mdw.customColor(color, this.colors.source);
      let onCustomColor = this.mdw.customColor(
        color,
        this.colors.source,
        onMode,
      );
      this.startColor = customColor.light;
      this.startDarkColor = customColor.dark;
      this.endColor = onCustomColor.light;
      this.endDarkColor = onCustomColor.dark;
      this.optionform.patchValue({
        bgstart: this.startColor,
        bgend: this.endColor,
        bgstartDark: this.startDarkColor,
        bgendDark: this.endDarkColor,
      });

      // if (this.isAndroid || this.sync) {
      //   this.button.button_color_schema.schemes.light[this.bgStartKey] = this.startColor;
      //   this.button.button_color_schema.schemes.dark[this.bgStartKey] = this.startDarkColor;
      // }
      // if (!this.isAndroid || this.sync) {
      //   this.button.button_color_schema_ios.schemes.light[this.bgStartKey] = this.startColor;
      //   this.button.button_color_schema_ios.schemes.dark[this.bgStartKey] = this.startDarkColor;
      // }
      // if (this.isAndroid || this.sync) {
      //   this.button.button_color_schema.schemes.light[this.bgEndKey] = this.endColor;
      //   this.button.button_color_schema.schemes.dark[this.bgEndKey] = this.endDarkColor;
      // }
      // if (!this.isAndroid || this.sync) {
      //   this.button.button_color_schema_ios.schemes.light[this.bgEndKey] = this.endColor;
      //   this.button.button_color_schema_ios.schemes.dark[this.bgEndKey] = this.endDarkColor;
      // }
      // this.updateButtonData();
    }
  }

  endColorChange(value, manual, mode = "color") {
    let color = null;
    let onMode: string;
    if (mode == "color") {
      onMode = "colorContainer";
    } else {
      onMode = "color";
    }
    color =
      manual == true
        ? this.mdw.isValidHexaCode(value.target.value)
          ? value.target.value
          : null
        : value;
    if (color) {
      this.isAndroid =
        localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      this.colors = this.isAndroid
        ? this.config.scheme_color.color_schema
        : this.config.scheme_color.color_schema_ios;
      let customColor = this.mdw.customColor(color, this.colors.source);
      let onCustomColor = this.mdw.customColor(
        color,
        this.colors.source,
        onMode,
      );
      this.endColor = customColor.light;
      this.endDarkColor = customColor.dark;
      this.startColor = onCustomColor.light;
      this.startDarkColor = onCustomColor.dark;
      this.optionform.patchValue({
        bgstart: this.startColor,
        bgend: this.endColor,
        bgstartDark: this.startDarkColor,
        bgendDark: this.endDarkColor,
      });
      // if (this.isAndroid || this.sync) {
      //   this.button.button_color_schema.schemes.light[this.bgEndKey] = this.endColor;
      //   this.button.button_color_schema.schemes.dark[this.bgEndKey] = this.endDarkColor;
      // }
      // if (!this.isAndroid || this.sync) {
      //   this.button.button_color_schema_ios.schemes.light[this.bgEndKey] = this.endColor;
      //   this.button.button_color_schema_ios.schemes.dark[this.bgEndKey] = this.endDarkColor;
      // }
      // if (this.isAndroid || this.sync) {
      //   this.button.button_color_schema.schemes.light[this.bgStartKey] = this.startColor;
      //   this.button.button_color_schema.schemes.dark[this.bgStartKey] = this.startDarkColor;
      // }
      // if (!this.isAndroid || this.sync) {
      //   this.button.button_color_schema_ios.schemes.light[this.bgStartKey] = this.startColor;
      //   this.button.button_color_schema_ios.schemes.dark[this.bgStartKey] = this.startDarkColor;
      // }
      // this.updateButtonData();
    }
  }

  saveImages(imges: any[]) {
    if (this.isAndroid || this.sync) {
      this.optionform.patchValue({
        image: imges && imges.length > 0 ? imges[0].media.permanentUrl : "",
      });
    }
    if (!this.isAndroid || this.sync) {
      this.optionform.patchValue({
        image_ios: imges && imges.length > 0 ? imges[0].media.permanentUrl : "",
      });
    }
  }

  getIcon(opt) {
    if (this.isAndroid) {
      return this.builderService.getIcon(opt.icon);
    } else {
      return this.builderService.getIcon(opt.icon_ios);
    }
  }

  toggleDivider(e) {
    const status = e.target.checked;
    if (this.sync) {
      this.optionform.patchValue({
        divider: status,
        divider_ios: status,
      });
    } else {
      if (this.isAndroid) {
        this.optionform.patchValue({
          divider: status,
        });
      }

      if (!this.isAndroid) {
        this.optionform.patchValue({
          divider_ios: status,
        });
      }
    }
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }

    if (this.listChatTagsSubscription) {
      this.listChatTagsSubscription.unsubscribe();
    }
    if (this.verifySubscription) {
      this.verifySubscription.unsubscribe();
    }
  }
}
